import React from 'react';
import Button from '../components/elements/button';
import '../assets/css/pages/about.css';
import FeatureItem from '../components/elements/feature_item';
import about from '../assets/images/group_photo.png';
import team1 from '../assets/images/olanike.png';
import team2 from '../assets/images/Aina.jpeg';
import team3 from '../assets/images/selim.jpg';
import team4 from '../assets/images/Mubarak.png';
import community_bg from '../assets/images/community-bg.png';
import { Arrow, Community, GreenStarsLeft, GreenStarsRight, Lightbulb, MapIdentify, Monitor, Question, Shop } from '../assets/icons';

const About = () => {
    const achievements = [
        {
            percentage: "95%",
            title: "Customer Satisfaction",
            boldText: "Satisfaction",
            description: "Our clients report improved aquaculture health management"
        },
        {
            percentage: "80%",
            title: "Disease Prevention",
            boldText: "Prevention",
            description: "Reduction in disease outbreaks through early detection"
        },
        {
            percentage: "60%",
            title: "Cost Reduction",
            boldText: "Reduction",
            description: "Average reduction in operational costs"
        }
    ];

    const features = [
        {
            icon : <img src={Lightbulb} alt="" />,
            title: "Educational Resources",
        description: "Learn best practices for sustainable and smart fish farming through expert-led courses.",
            link: "/learning"
        },
        {
            icon : <img src={MapIdentify} alt="" />,
            title: "Advanced Diagnostics",
        description: "AI-powered tools for early detection and prevention of aquaculture diseases.",
            link: "/aqua-doc"
        },
        {
            icon : <img src={Shop} alt="" />,
            title: "Multivendor E-commerce",
        description: "Connect with trusted suppliers for high-quality aquaculture products, equipment, and feed.",
            link: "/store"
        },
        {
            icon : <img src={Monitor} alt="" />,
            title: "AI Health Monitoring",
            description: "Real-time monitoring of water quality, fish health, and environmental factors.",
            link: "/chat"
        },
        {
            icon : <img src={Question} alt="" />,
            title: "Veterinary Consultations",
            description: "Access expert aquatic veterinarians for professional guidance and treatment plans.",
            link: "/doctors"
        },
        {
            icon : <img src={Community} alt="" />,
            title: "Community Forums",
            description: "Engage with industry professionals, share insights, and stay updated on the latest aquaculture trends.",
            link: "/community"
        }
    ];

    const teamMembers = [
        {
            image: team1,
            name: "Prof. Olanike K. Adeyemo",
            honours: "FCVSN, FEnv, FAAS, FAS, FTWAS",
            position: "Principal Investigator"
        },
        {
            image: team2,
            name: "Dr. Oluwasanmi Aina",
            honours: "DVM, PhD, FCVSN",
            position: "Co-Principal Investigator"
        },
        {
            image: team3,
            name: "Dr. Selim Alarape",
            honours: "DVM, MVPH, PhD",
            position: "Lead Scientist"
        },
        {
            image: team4,
            name: "Mubarak Akingboye",
            honours: "GMNCS, GMNIM, mMBA",
            position: "Product Manager"
        }
    ];

    return (
        <div className="about-page">
            {/* Header Section */}
            <section className="about-header">
                <div className="about-header-content">
                    <div className="header-left">
                        <h1>Transforming Aquaculture Health Management</h1>
                        <p>Leading the revolution in aquaculture health monitoring through innovative AI-powered solutions.</p>
                        <blockquote>"Empowering sustainable aquaculture through technology"</blockquote>
                    </div>
                    <div className="header-right">
                        <img src={about} alt="Aquaculture Facility" />
                    </div>
                </div>
            </section>

            {/* Video Section */}
            <section className="video-section">
                <iframe 
                    width="100%" 
                    height="500" 
                    src="https://www.youtube.com/embed/YGaFNZzjCXI" 
                    title="About E-AquaHealth" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                />
            </section>

            {/* What We Do Section */}
            <section className="what-we-do">
                <h2>What We Do</h2>
                <p className="section-description">
                At E-AquaHealth, we understand the unique challenges of fish farming. That is why we’ve designed a platform that is more than just a service provider- it’s a partner in your success. Our advanced diagnostic tools, expert support network, and comprehensive educational resources are tailored to help you maintain healthy fish stock, optimize your operations, and achieve your farming goals. Whether you’re an experienced farmer or just starting out, E-AquaHealth is here to provide the solutions and support you need to thrive.
                </p>
                <p className="section-description">
                We provide a comprehensive suite of services designed to support the health and productivity of aquaculture farms. Our mission is to help fish farmers and aquatic health professionals prevent diseases, optimize farm conditions, and ensure sustainable aquaculture practices.
                </p>
                <p className="section-description">
                We specialize in case reporting and disease diagnosis, allowing farmers to quickly report fish health issues through our intuitive platform. Using AI-powered analysis and expert veterinary reviews, we offer accurate disease identification and actionable treatment recommendations. Our goal is to minimize losses and enhance fish health management.
                </p>
                <p className="section-description">
                Beyond disease diagnostics, we offer smart farm health tracking, which provides real-time insights into water quality and environmental conditions. By integrating advanced monitoring systems, we enable farmers to detect potential risks early and take proactive measures to protect their stock.
                </p>
                <p className="section-description">
                We also foster industry collaboration through our multi-vendor marketplace and community forums. Farmers can easily access high-quality aquaculture supplies, connect with trusted vendors, and engage with industry professionals to share knowledge and best practices.
                </p>
                <p className="section-description">
                Additionally, our training programs and resources equip farmers and veterinarians with the latest aquaculture management techniques. From disease prevention strategies to sustainable farming practices, we provide expert-led courses that empower users to make informed decisions for long-term success.
                </p>
                <div className="features-grid">
                    {features.map((f, i) => (
                        <FeatureItem
                        icon={f.icon}
                        title={f.title}
                        description={f.description}
                        key={i}
                        />
                    ))}
                </div>
            </section>

            {/* Achievements Section */}
                        <section className="achievements">
                            <h2>OUR Achievements</h2>
                            <div className="achievements-grid">
                                {achievements.map((achievement, index) => (
                                    <div key={index} className="achievement-card">
                                        <span className="percentage">{achievement.percentage}</span>
                                        <p dangerouslySetInnerHTML={{
                                            __html: achievement.title.replace(achievement.boldText, `<strong>${achievement.boldText}</strong>`)
                                        }} />
                                        <p>{achievement.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Team Section */}
            <section className="team-section">
                <p style={{ fontFamily:"Merriweather", display:"flex", justifyContent:"center", alignItems:"center" }}><img src={GreenStarsRight} alt="" style={{height:"13px"}} /> Meet the Team <img src={GreenStarsLeft} alt="" style={{height:"13px"}} /></p>
                <h2>Discover Our Team</h2>
                <div className="team-grid">
                    {teamMembers.map((member, index) => (
                        <div 
                            key={index} 
                            className="team-card" 
                            // style={{ backgroundImage: `url(${member.image})` }}
                            style={{ backgroundImage: `url(${member.image})` }}
                        >
                            <div className="member-info">
                                <h3>{member.name}</h3>
                                <p><small><em>{member.honours}</em></small></p>
                                <p>{member.position}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Community Section */}
            <section className="community-section">
                <h2>Join Our Community</h2>
                <p>Be part of the future of aquaculture health management</p>
                <Button 
                    text="Join Our Community" 
                    variant="primary"
                    icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
                    onClick={() => window.location.href = '/community'}
                />
                <img src={community_bg} alt="Community" className='community_bg'/>
            </section>
        </div>
    );
};

export default About;